/**
 * Deals with side menu items labels
 */
export class SideMenuItems {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public menu: string = 'menu', // NOSONAR
    public addPoints: string[] = ['add-points', 'stars'], // NOSONAR
    public home: string[] = ['home', 'house'], // NOSONAR
    public rewards: string[] = ['rewards', 'local_activity'], // NOSONAR
    public coupons: string[] = ['coupons', 'redeem'], // NOSONAR
    public pointBalance: string[] = [
      'point-balance-list',
      'account_balance_wallet',
    ], // NOSONAR
    public printers: string[] = ['printers', 'print'], // NOSONAR
    public businessSettings: string[] = ['business-settings', 'domain'], // NOSONAR
    public accountSettings: string[] = ['account-settings', 'settings'], // NOSONAR
    public faq: string[] = ['faq', 'help'], // NOSONAR
    public help: string[] = ['help-menu', 'help'], // NOSONAR
    public termsOfUse: string[] = ['terms-of-use', 'help'] // NOSONAR
  ) {}

  /**
   * Side menu items that always show on desktop
   */
  get flatNavItems() {
    return [this.home, this.addPoints];
  }

  /**
   * Side menu items that show upon menu expansion
   */
  get expandedMenuNavItems() {
    return [
      this.rewards,
      this.coupons,
      this.pointBalance,
      this.businessSettings,
      this.accountSettings,
    ];
  }

  /**
   * Side menu items that show upon menu expansion
   */
  get expandedHelpMenuItems() {
    return [this.faq, this.termsOfUse];
  }

  /**
   * Help menu item
   */
  get helpMenuItem() {
    return [this.help];
  }

  /**
   * Navigation bar items that show on mobile
   */
  get navigationBarItems() {
    return [this.home, this.addPoints];
  }
}
